import axios from "axios";
import { BASE_URL } from "utils/constants";
import { arrayBufferToBase64 } from "utils/util";

class App_photos {
  async updateProjectPhotos(parameters = {}) {
    let result;
    const url = `${BASE_URL}/api/photos/update_photos_companycamp`;
    try {
      const response = await axios.put(url, parameters);
      result = response.data;
    } catch (err) {
      result = {
        status: "desconnected",
        message: "Could not connect to service",
      };
    }
    return result;
  }
  async getCompanyCamPhotosById(projectId) {
    let result;
    const url = `${BASE_URL}/api/photos/get-companycam-photos/${projectId}`;
    try {
      const response = await axios.get(url);
      result = response.data;
    } catch (err) {
      result = {
        status: "desconnected",
        message: "Could not connect to service",
      };
    }
    return result;
  }

  async getTotalPhotos() {
    let result;
    const url = `${BASE_URL}/api/photos/getTotalPhotos`;
    await axios
      .get(url)
      .then((response) => {
        result = response.data.data;
      })
      .catch((err) => {
        result = null;
      });

    return result;
  }

  
  /**
   * Fetches one page of a project's photos, with pagination metadata.
   * @param {number} project_id - Project (app_measurements) ID
   * @param {string|null} imageSource - Optional tagImageSource filter
   * @param {number} size - Page size
   * @param {number} page - 1-based page number (sent as `pag`, the name the backend reads)
   * @returns {Promise<{photos: Array, totalPhotos: number, totalPages: number}>}
   */
  async getPhotosPageV2(project_id, imageSource, size = 10, page = 1) {
    const url = `${BASE_URL}/api/photos/v2/getPhotos`;
    try {
      const response = await axios.get(url, {
        params: { project_id, imageSource, size, pag: page, onlyWithoutCondition: true },
      });
      const { photos, totalPhotos, totalPages } = response.data.data;
      return { photos: photos || [], totalPhotos: totalPhotos || 0, totalPages: totalPages || 0 };
    } catch (err) {
      return { photos: [], totalPhotos: 0, totalPages: 0 };
    }
  }

  async getPhotosV2(project_id, imageSource, size = 10, page = 1) {
    const { photos } = await this.getPhotosPageV2(project_id, imageSource, size, page);
    return photos;
  }


  async updateUsedCompanyCamPhotos(ids = []) {
    let result;
    const url = `${BASE_URL}/api/photos/update-used-companycam-photos`;
    try {
      const response = await axios.put(url, { ids });
      result = response.data;
    } catch (err) {
      result = {
        status: "desconnected",
        message: "Could not connect to service",
      };
    }
    return result;
  }
  async updateAppPhotosFromCompanyCam(images, imageSource, projectId) {
    let result;
    const url = `${BASE_URL}/api/photos/update-app-photos-from-companycam`;
    try {
      const response = await axios.post(url, {
        images,
        imageSource,
        projectId,
      });
      result = response.data;
    } catch (err) {
      result = {
        status: "desconnected",
        message: "Could not connect to service",
      };
    }
    return result;
  }
}

export default new App_photos();
